import { combineReducers } from "redux"
import { groupCourseProgress } from "./groupCourseProgress"

export const educatorCourses = combineReducers({
  groupCourseProgress
})
